<div class="preview-container">
  <div class="preview-header">
    <div class="preview-title">
      <i class="fas fa-eye"></i>
      <span>Live Website Preview</span>
      <div class="template-info" style="display: none;">Template {{ selectedTemplate }} - {{ selectedTheme | titlecase }}</div>
    </div>
    <div class="preview-controls">
      <!-- Theme Picker Dropdown -->
      <div class="theme-picker-container">
        <button 
          class="theme-picker-btn icon-btn" 
          (click)="toggleThemePicker()"
          [class.active]="showThemePicker"
          title="Change website color theme">
          <i class="fas fa-palette"></i>
        </button>
        
        <!-- Theme Picker Dropdown -->
        <div class="theme-picker-dropdown" *ngIf="showThemePicker">
          <div class="theme-picker-header">
            <span>Choose Theme</span>
          </div>
          <div class="theme-options">
            <div class="theme-option" 
                 *ngFor="let theme of colorThemes | keyvalue" 
                 [class.selected]="selectedTheme === theme.key"
                 (click)="selectTheme(theme.key)">
              <div class="theme-color-preview" [style.background-color]="theme.value.primary"></div>
              <span class="theme-name">{{ theme.value.name }}</span>
              <i class="fas fa-check theme-check" *ngIf="selectedTheme === theme.key"></i>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Edit Mode Toggle Button -->
      <button 
        class="edit-mode-btn icon-btn" 
        [class.active]="isEditMode"
        *ngIf="hasAIContent"
        (click)="toggleEditMode()"
        [title]="isEditMode ? 'Switch to viewing mode - see your website as visitors will' : 'Switch to editing mode - click on text to make changes'">
        <i class="fas fa-mouse-pointer" *ngIf="!isEditMode"></i>
        <i class="fas fa-eye" *ngIf="isEditMode"></i>
      </button>
      
      <!-- Save Progress Button -->
      <button 
        class="save-progress-btn icon-btn" 
        (click)="saveProgress()"
        [disabled]="isSavingProgress"
        [title]="isSavingProgress ? 'Saving your work...' : 'Save your progress - don\'t lose your work!'">
        <i class="fas fa-bookmark" *ngIf="!isSavingProgress"></i>
        <i class="fas fa-spinner fa-spin" *ngIf="isSavingProgress"></i>
      </button>
      
      <!-- Deploy Now Button -->
      <button 
        class="deploy-btn icon-btn" 
        [class.deploy-ready]="isDeployButtonEnabled()"
        *ngIf="shouldShowDeployButton()"
        (click)="deployWebsite()"
        [disabled]="!isDeployButtonEnabled()"
        [title]="isDeployButtonEnabled() ? 'Publish your website online - make it live for everyone to see!' : 'Complete all the steps above to publish your website'">
        <i class="fas fa-globe-americas"></i>
      </button>
      
      <!-- Refresh Button -->
      <button class="control-btn icon-btn" (click)="refreshPreview()" title="Refresh your preview - reload the page" style="display: none;">
        <i class="fas fa-sync-alt"></i>
      </button>
    </div>
  </div>
  <div class="preview-content">
    <!-- Loading Overlay -->
    <div class="preview-loader" *ngIf="isLoading">
      <div class="loader-content">
        <div class="spinner"></div>
        <p>Loading preview...</p>
      </div>
    </div>
    
    <iframe 
      #previewFrame
      frameborder="0"
      class="preview-iframe"
      allow="scripts"
      sandbox="allow-scripts allow-same-origin allow-forms"
      (load)="onIframeLoad()">
    </iframe>
  </div>
  
  <!-- Inline Content Editor removed; now handled in builder -->
</div>
